/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_donut_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a donut chart from pasted data — proportions with a clean centre, no sign-up.`)
};

const es_donut_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un gráfico de dona a partir de datos pegados — proporciones con un centro limpio, sin registro.`)
};

const de_donut_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen Sie ein Donut-Diagramm aus eingefügten Daten — Anteile mit sauberer Mitte, keine Anmeldung erforderlich.`)
};

const nl_donut_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak een donutdiagram van geplakte data — aandelen met een opgeschoond midden, geen registratie nodig.`)
};

const fr_donut_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez un diagramme en anneau à partir de données collées — proportions avec un centre épuré, sans inscription.`)
};

const it_donut_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un grafico a ciambella dai dati incollati — proporzioni con un centro pulito, senza registrazione.`)
};

const pt_br2_donut_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um gráfico de rosca a partir de dados colados — proporções com um centro limpo, sem cadastro.`)
};

const pt_donut_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um gráfico de rosca a partir de dados colados — proporções com um centro limpo, sem registo.`)
};

const ja_donut_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`貼り付けたデータからドーナツグラフを作成します — すっきりした中央部を持つ割合表示、登録不要。`)
};

const zh_donut_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据粘贴的数据创建环形图——中心简洁的占比展示，无需注册。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const donut_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.donut_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("donut_tool_description", locale)
	if (locale === "en") return en_donut_tool_description(inputs)
	if (locale === "es") return es_donut_tool_description(inputs)
	if (locale === "de") return de_donut_tool_description(inputs)
	if (locale === "nl") return nl_donut_tool_description(inputs)
	if (locale === "fr") return fr_donut_tool_description(inputs)
	if (locale === "it") return it_donut_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_donut_tool_description(inputs)
	if (locale === "pt") return pt_donut_tool_description(inputs)
	if (locale === "ja") return ja_donut_tool_description(inputs)
	return zh_donut_tool_description(inputs)
};